import React, { useState } from 'react';
import Privacy from '../../privacy/Privacy';
import './jobApplyConsentModal.css';

/**
 * 채용 지원서 작성 시에만 사용하는 개인정보 수집·이용 동의 모달.
 * 홈페이지 전체 개인정보처리방침(Privacy)과 별도의 안내 문구를 둡니다.
 */
function JobApplyConsentModal({ jobTitle, onAgree, onDismiss }) {
  const [showFullPrivacy, setShowFullPrivacy] = useState(false);

  return (
    <>
      <div
        className="job-apply-consent-overlay"
        onClick={onDismiss}
        role="presentation"
        aria-hidden="true"
      />
      <div
        className="job-apply-consent-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="job-apply-consent-title"
      >
        <header className="job-apply-consent-header">
          <button
            type="button"
            className="job-apply-consent-back"
            onClick={onDismiss}
            aria-label="닫기"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <h1 id="job-apply-consent-title" className="job-apply-consent-title">
            채용 지원 개인정보 수집·이용 동의
          </h1>
        </header>

        <div className="job-apply-consent-body">
          <p className="job-apply-consent-lead">
            주식회사 가까운물류(이하 &quot;회사&quot;)는 채용 전형 진행을 위해 「개인정보 보호법」에 따라
            아래와 같이 개인정보를 수집·이용합니다. 내용을 확인하신 후 동의해 주세요.
          </p>

          {jobTitle ? (
            <p className="job-apply-consent-job">
              <span className="job-apply-consent-job-label">지원 공고</span>
              <span className="job-apply-consent-job-value">{jobTitle}</span>
            </p>
          ) : null}

          <section className="job-apply-consent-section">
            <h2 className="job-apply-consent-h2">1. 수집·이용 목적</h2>
            <p className="job-apply-consent-p">
              채용 공고에 따른 지원자 본인 확인, 채용전형 진행·관리, 합격 여부 통지, 입사 시 인사 기록,
              채용 관련 통계·분석 및 법령상 의무 이행
            </p>
          </section>

          <section className="job-apply-consent-section">
            <h2 className="job-apply-consent-h2">2. 수집 항목</h2>
            <p className="job-apply-consent-p">
              성명, 연락처(휴대전화), 이메일, 비밀번호(지원서 조회용), 주소, 생년월일, 성별, 국적,
              사진, 경력·학력 등 지원서에 기재하신 정보, 자격·차량 관련 정보 및 기타 지원에 필요한 정보
            </p>
          </section>

          <section className="job-apply-consent-section">
            <h2 className="job-apply-consent-h2">3. 보유·이용 기간</h2>
            <p className="job-apply-consent-p">
              채용절차 종료 후 지원자의 불합격 통지 시점으로부터 180일까지 보관 후 지체 없이 파기합니다.
              단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관할 수 있습니다.
            </p>
          </section>

          <section className="job-apply-consent-section">
            <h2 className="job-apply-consent-h2">4. 동의 거부에 따른 불이익</h2>
            <p className="job-apply-consent-p">
              위 개인정보 수집·이용에 동의하지 않을 수 있으나, 동의하지 않을 경우 채용 지원 및 전형 진행이
              제한될 수 있습니다.
            </p>
          </section>

          <p className="job-apply-consent-note">
            회사의 전체 개인정보 처리에 관한 사항은{' '}
            <button
              type="button"
              className="job-apply-consent-link"
              onClick={() => setShowFullPrivacy(true)}
            >
              개인정보처리방침
            </button>
            을 참고해 주세요.
          </p>
        </div>

        <footer className="job-apply-consent-footer">
          <button type="button" className="job-apply-consent-btn-secondary" onClick={onDismiss}>
            닫기
          </button>
          <button type="button" className="job-apply-consent-btn-primary" onClick={onAgree}>
            동의합니다
          </button>
        </footer>
      </div>

      {showFullPrivacy && (
        <div className="job-apply-consent-privacy-layer">
          <Privacy embedded onClose={() => setShowFullPrivacy(false)} />
        </div>
      )}
    </>
  );
}

export default JobApplyConsentModal;
